import React, { type ReactElement } from 'react';

import Image from 'next/image';

import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button';
import Drawer from '@/common/components/drawer/drawer.component';
import { type ExtraDetails } from '@/common/components/store-widget/store-widget.component';
import Text from '@/common/components/text';

import VendorInfoDetails from './vendor-info-details';

export interface VendorInfoDrawerProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  logo: string;
  title: string;
  description: string;
  action: () => void;
  extraDetails: ExtraDetails;
}

export default function VendorInfoDrawer({
  isOpen,
  setOpen,
  logo,
  title,
  description,
  action,
  extraDetails,
}: VendorInfoDrawerProps): ReactElement {
  return (
    <Drawer
      rootClassName="lg:hidden"
      className="category-drawer flex flex-col justify-between rounded-t-2xl"
      placement="bottom"
      open={isOpen}
      onClose={() => {
        setOpen(false);
      }}
      height={'auto'}
    >
      <div className="mb-8 flex w-full flex-col items-center">
        <div className="mt-6 flex h-20 w-20 items-center justify-center overflow-hidden rounded-full border-2 border-primary-100">
          <Image src={logo} alt="vendor-logo" width={80} height={80} />
        </div>
        <Text className="mt-4 text-sm font-semibold text-black-400">
          {title}
        </Text>
        <Text className="mt-3 block text-center text-xs font-normal text-black-300">
          {description}
        </Text>
      </div>

      <VendorInfoDetails extraDetails={extraDetails} />
      <AnalyticsWrapper analytics={['store-click-view-store-v1']}>
        <Button onClick={action} className="w-full" type="black">
          مشاهده فروشگاه
        </Button>
      </AnalyticsWrapper>
    </Drawer>
  );
}
